<script setup lang="ts">
import PaymentComponent from "@/builder/components/payment/PaymentComponent.vue";
import { MerchantType } from "@/enums";
import { useRenderStore } from "../../stores/renderStore";

const renderStore = useRenderStore();

const organizationId = renderStore.organizationId;

const merchantAccount = renderStore.merchantAccount ?? "";
const tokenizationKey = renderStore.tokenizationKey ?? "";
const readOnly = false;
const props = defineProps(["component"]);

const payPalGatewayId = renderStore.page.payPalGatewayId;
const payPalMerchantAccount = renderStore.page.payPalMerchantAccount;
const payPalCurrency = renderStore.page.payPalGatewayCurrency;
const merchantType = renderStore.page.merchantType ?? MerchantType.StripeUnified;
</script>

<template>
    <payment-component :component="props.component" :organizationId="organizationId" :merchantAccount="merchantAccount"
        :tokenizationKey="tokenizationKey" :readOnly="readOnly" :payPalGatewayId="payPalGatewayId"
        :payPalMerchantAccount="payPalMerchantAccount" :payPalCurrency="payPalCurrency" :merchantType="merchantType" />
</template>
